import React from 'react';
import Profile from './Profile';
import RestaurantDashboardLayout from './RestaurantDashboardLayout';
import { useRestaurantEnabledServices } from './useRestaurantEnabledServices';
import '../admin/EatsAdminDashboard.css';

/**
 * Business portal profile — same Profile UI as eats admin, inside restaurant shell.
 * Uses enabled services so sidebar matches other business pages (e.g. Dine-In only if opted in).
 */
const BusinessProfilePage = () => {
  const { enabledTypes: enabledServiceTypes, loading: servicesLoading } =
    useRestaurantEnabledServices();

  return (
    <RestaurantDashboardLayout
      activeTab=""
      flush={false}
      enabledServiceTypes={enabledServiceTypes}
      servicesLoading={servicesLoading}
    >
      <h2 className="eats-admin-dashboard__title">Profile</h2>
      <p className="eats-admin-dashboard__subtitle">
        Manage your account details and password for this business.
      </p>
      <Profile embedded />
    </RestaurantDashboardLayout>
  );
};

export default BusinessProfilePage;
